// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ChevronUp(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronUp" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M12.3536 7.94141L18.7071 14.295L16.9437 16.0583L12.3536 11.4781L7.76336 16.0583L6 14.295L12.3536 7.94141Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ChevronUp.js.map